import templateUrl from "emun.cart/cart-item-quick-view-sizeoptions.htm";

export default () => ({
  templateUrl
});
